import { coreApi } from "./coreApi";

export const journalEntriesApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getJournalEntries: builder.query({
      query: () => `/accounting/journal-entries`,
      providesTags: ["JournalEntries"],
    }),
    createJournalEntry: builder.mutation({
      query: (journalEntry) => ({
        url: "/accounting/journal-entries/store",
        method: "POST",
        body: journalEntry,
      }),
      invalidatesTags: ["JournalEntries"],
    }),
    migrateJournalEntry: builder.mutation({
      query: (id) => ({
        url: `/accounting/journal-entries/post/${id}`,
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["JournalEntries"],
    }),
    cancelJournalEntry: builder.mutation({
      query: (id) => ({
        url: `/accounting/journal-entries/cancel/${id}`,
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["JournalEntries"],
    }),
  }),
});

export const {
  useGetJournalEntriesQuery,
  useCreateJournalEntryMutation,
  useMigrateJournalEntryMutation,
  useCancelJournalEntryMutation,
} = journalEntriesApi;

export default journalEntriesApi;
